import { getPermissionResource } from '../constants/permissions';

/* Expands permission values with their resource wildcard,
   e.g. 'clientSubscription:get' -> ['clientSubscription:get', 'clientSubscription:*'] */
export const withResourceWildcard = (...values) => [
  ...new Set(values.flatMap((value) => [value, `${getPermissionResource(value)}:*`])),
];

export const hasPermission = (permissions, scopes) => {
  if (!permissions || permissions?.length === 0) {
    return false;
  }

  const scopesMap = scopes.reduce((acc, curr) => {
    acc[curr] = true;

    return acc;
  }, {});

  return permissions.some((permission) => scopesMap[permission.name] || permission.name === '*');
};
